import { useAppSelector } from '~/redux/hooks'
import { selectTutorForSelfCart } from '~/redux/slices/cart'
import { isTutoringForSelfCartValid } from '~/booking/utils/booking-form-validation'

export default function useIsValidTutorForSelfCart(): boolean {
  const cart = useAppSelector(selectTutorForSelfCart)

  return isTutoringForSelfCartValid(cart)
}
